module.exports = __webpack_public_path__ + "static/necklace_of_prayer_beads-20e8894d01f5e4f5e869f9d696dd8c97.jpeg";